<template>
    <v-container>
        <v-row no-gutters v-if="loading">
            <v-col cols="12">
                <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                ></v-progress-circular>
            </v-col>
        </v-row>
        <v-row no-gutters v-else>
            <v-col class="d-flex flex-grow-0 flex-shrink-1">
                <slot name="item_action"></slot>
            </v-col>
            <v-col class="d-flex flex-grow-1 flex-shrink-0">
                <InstrumentItemInfo
                    :instrument="instrument"
                    :location="loc"
                    :show_platform_capacity="show_platform_capacity">
                    <slot name="other_info"></slot>
                </InstrumentItemInfo>
            </v-col>
        </v-row>
        <v-row no-gutters><v-col cols="12"><slot></slot></v-col></v-row>
    </v-container>
</template>
<script>
// import _ from 'lodash'

import InstrumentItemInfo from "../instruments/InstrumentItemInfo"

export default {
    components: {InstrumentItemInfo},
    props: {
        instrument_id: {
            type: String,
            required: true
        },
        override_location: {
            type: Boolean,
            required: false,
            default: false
        },
        location: {
            type: Object,
            required: false,
            default: null
        },
        show_platform_capacity: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
            loading: true,
            instrument: null,
            loc: null
        }
    },
    computed: {
        
    },
    async mounted() {
        await this.loadInstrument()
    },
    methods: {
        async loadInstrument() {
            this.loading = true
            this.instrument = await this.$store.state.$pouch.get('registry', this.instrument_id)
            this.loc = this.location
            // override current location
            if (this.override_location) {
                this.loc = await this.$store.state.$pouch.get('registry', this.instrument.location_id)
            }
            this.loading = false
        }
    },
    
    
}

</script>